// src/mixins/clickMixin.js

const citiesPLLatLng = require('@/data/citiesPL.json')
// const casesPL = require('@/data/casesPL.json')

// const casesPL = window.localStorage.casesPL

const slugify = require('slugify')
export default {
  data: () => {
    return {
      allCases() {
        return this.items
          .map(item => {
            return item.infected
          })
          .sort((a, b) => b - a)
      }
    }
  },
  methods: {
    calcRadius(casesNr) {
      // const cofactor = 1000
      // return casesNr * cofactor
      if (casesNr < 4) {
        return 4
      }
      if (casesNr > 10) {
        return 10
      }
      return casesNr
    },

    getCitiesPL() {
      console.log('xxxx', this.items)
      const citiesPL = this.items.map(item => {
        // let coordinates = [21.01223, 52.229675]
        console.log(item)
        const cityData = citiesPLLatLng.filter(city => {
          // return city.name.match(item.name)
          return city.name.toLowerCase() === item.name.toLowerCase()
        })

        const coordinates = cityData[0]
          ? [parseFloat(cityData[0].lng), parseFloat(cityData[0].lat)]
          : [0, 0]

        const radiusSize = this.calcRadius(item.infected)

        return {
          type: 'Feature',

          properties: {
            name: item.name,
            cases: item.infected,
            cured: item.cured,
            deaths: item.deaths,

            radius: radiusSize
          },
          id: slugify(item.name),
          geometry: {
            type: 'Circle',
            coordinates: coordinates,
            radius: radiusSize
            // radius: 10000
          }
        }
      })

      console.log('xxxx', citiesPL)

      return citiesPL
    }
  }
}
